import { decodeJWT } from '@siteground/styleguide';

export const getUserData = (storeState) => ({
  firstName: storeState.chatSession.firstName,
  lastName: storeState.chatSession.lastName
});

export const getClientToken = (storeState) => storeState.chatSession.clientToken;

export const getClientJWTPayload = (storeState) => {
  const clientToken = getClientToken(storeState);

  if (clientToken) {
    return decodeJWT(clientToken);
  }
};

export const getLanguage = (storeState) => storeState.chatSession.language;
export const getImpulseURLs = (storeState) => storeState.chatSession.IMPULSE_URLS;
export const getVisitorToken = (storeState) => storeState.chatSession.visitorToken;

export const isUserLoggedFromMaco = (storeState) => {
  if (isRoleOverruled()) {
    return false;
  }

  const clientToken = getClientToken(storeState);

  if (!clientToken) {
    return false;
  }

  const jwtData = decodeJWT(clientToken);

  const { roles = [] } = jwtData;

  return Boolean(
    roles && Boolean(roles.includes('ROLE_IMPERSONATED_USER') || roles.includes('ROLE_IMPERSONATED_USER_FULL'))
  );
};

function isRoleOverruled() {
  // @ts-ignore
  const shouldEnable = parseInt(window.enable_chat_from_maco);
  return shouldEnable === 1;
}

export const getIsAuthorized = (storeState) => !storeState.chatSession?.unauthorized;
